<template>
  <div style="display: flex;align-items: flex-end;">
    <el-upload class="upload-demo" drag action="" :auto-upload="false" list-type="picture" :limit="picLimit" :on-exceed="handleExceed" 
      :on-change="changeFileList" ref="upload">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>
    <!-- <div class="tipInfoSpan">只能上传jpg/png文件，且不超过5M</div> -->
  </div>
</template>

<script>
export default {
  props:{
    picLimit:{
      type:Number,
      default:1
    }
  },
  methods:{
    handleExceed(files, fileList) {
      this.$message.warning('当前限制选择 '+this.picLimit+' 张图片');
    },
    changeFileList(file) {
      this.handleBeforeUpload(file)
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file,fileList) {
      var flag = true
      // 校检文件类型
      if (file) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        if (fileExtension!='jpg'&&fileExtension!='png'&&fileExtension!='jpeg'&&fileExtension!='JPG') {
          this.$message.error( `文件格式不正确, 请上传jpg/png格式文件!`);
          flag = false
        }
        const isLt = file.size / 1024  < 5121;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 500kb`);
          flag = false
        }
      }
      if(flag){
        this.fileList.push(file)
      }
    },
  },
  data(){
    return{
      fileList:[]
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-demo{
  /deep/ .el-upload__tip{
    font-size: 0.12rem;
    color: #618C04;
    margin-left: 0.2rem;
    float: right;
    margin-top: 1.6rem;
  }
  /deep/ .el-upload-list{
    display: flex;
    flex-wrap: wrap;
    width: 6.4rem;
  }
  /deep/ .el-upload-list__item{
    border: none;
    background-color: #F7F7F7;
    width: 1.6rem;
    height: 1.7rem;
  }
  /deep/ .el-upload-list__item-name{
    position: absolute;
    top: 1.37rem;
    margin-top: 0.1rem;
    left: 0.01rem;
    width: 1.37rem;
    margin-right: 0rem;
  }
  /deep/ .el-icon-document{
    display: none;
  }
  /deep/ .el-icon-close{
    display: block;
  }
  /deep/ .el-upload-list__item-thumbnail{
    width: 1.27rem;
    height: 1.27rem;
  }
}
</style>